import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingRigSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 2.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1.27L20 17h5.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-23a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5H8l2.77-12H9.5a.5.5 0 0 1-.5-.5v-2ZM13.077 8 11 17h6l-2.077-9h-1.846Z"
    />
    <path d="M4 13.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2ZM21 13.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2ZM3.845 22 2 25.196V22.5a.5.5 0 0 1 .5-.5h1.345ZM4.226 26l2.31-4h2.31l-2.31 4h-2.31ZM11.536 22l-2.31 4h2.31l2.31-4h-2.31ZM14.226 26l2.31-4h2.31l-2.31 4h-2.31ZM21.536 22l-2.31 4h2.31l2.31-4h-2.31ZM24.226 26 26 22.928V25.5a.5.5 0 0 1-.5.5h-1.274Z" />
  </svg>
);
export default IconDrillingRigSizeL;
